import React from 'react'



export const CheckBox: React.FC<any> = ({...rest})=>{
    return (
        <>
            <input type='checkbox' {...rest} />
        </>
    )
}


